import React from 'react';
import PropTypes from 'prop-types';
import { NavigationLink as CoreNavigationLink } from 'gatsby-theme-thepuzzlers-core';
// Local imports
import { PageLink } from './components';

export const NavigationLink = (props) => (
  <CoreNavigationLink PageLink={PageLink} {...props} />
);

NavigationLink.propTypes = {
  to: PropTypes.string.isRequired
};
